import { Link } from "react-router-dom";
import { Linkedin, Twitter, Instagram, Facebook, Youtube, BookOpen } from "lucide-react";
import { useContent } from "../context/ContentContext";

const SOCIALS = [
  { Icon: Linkedin, href: "https://www.linkedin.com/company/112947912", label: "Master Odor Removal on LinkedIn" },
  { Icon: Twitter, href: "https://x.com/realMasterOdor", label: "Master Odor Removal on X" },
  { Icon: Instagram, href: "https://www.instagram.com/masterodorremoval/", label: "Master Odor Removal on Instagram" },
  { Icon: Facebook, href: "https://www.facebook.com/masterodorremovalbocaraton/", label: "Master Odor Removal on Facebook" },
  { Icon: Youtube, href: "https://www.youtube.com/c/masterodorremoval", label: "Master Odor Removal on YouTube" },
  { Icon: BookOpen, href: "https://masterodorremoval.com/resources/", label: "Master Odor Removal Resources" },
];

export default function Footer() {
  const { c } = useContent();
  return (
    <footer className="bg-[var(--navy-900)] text-slate-300">
      <div className="mx-auto max-w-[1200px] px-5 py-16 lg:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-[10px] bg-white text-[var(--navy)] font-extrabold text-lg">O</div>
              <div className="leading-none">
                <div className="font-display text-[17px] font-extrabold text-white">{c.brand.line1}</div>
                <div className="mt-[3px] text-[10px] font-semibold tracking-[0.22em] text-slate-400">{c.brand.line2}</div>
              </div>
            </div>
            <p className="mt-5 max-w-xs text-[14px] leading-relaxed text-slate-400">{c.footer.description}</p>

            <div className="mt-6">
              <h4 className="text-[12px] font-bold uppercase tracking-wider text-white">Connect With Us</h4>
              <div className="mt-4 flex flex-wrap items-center gap-2">
                {SOCIALS.map(({ Icon, href, label }, i) => (
                  <a
                    key={i}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={label}
                    title={label}
                    className="flex h-9 w-9 items-center justify-center rounded-lg border border-white/10 text-slate-400 transition-colors hover:border-white/20 hover:text-white"
                  >
                    <Icon size={17} />
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-[12px] font-bold uppercase tracking-wider text-white">Compare</h4>
            <ul className="mt-4 space-y-3 text-[14px]">
              <li><Link to="/compare" className="text-slate-400 transition-colors hover:text-white">Compare Methods</Link></li>
              <li><Link to="/providers" className="text-slate-400 transition-colors hover:text-white">Compare Providers</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-[12px] font-bold uppercase tracking-wider text-white">Directory</h4>
            <ul className="mt-4 space-y-3 text-[14px]">
              <li><Link to="/providers" className="text-slate-400 transition-colors hover:text-white">All Providers</Link></li>
              <li><Link to="/locations" className="text-slate-400 transition-colors hover:text-white">Locations</Link></li>
              <li><Link to="/providers/master-odor-removal" className="text-slate-400 transition-colors hover:text-white">Editor's Choice</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-[12px] font-bold uppercase tracking-wider text-white">Resources</h4>
            <ul className="mt-4 space-y-3 text-[14px]">
              <li><Link to="/resources" className="text-slate-400 transition-colors hover:text-white">Resources</Link></li>
              <li><Link to="/resources" className="text-slate-400 transition-colors hover:text-white">FAQ</Link></li>
              <li><Link to="/about" className="text-slate-400 transition-colors hover:text-white">About</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 border-t border-white/10 pt-6">
          <p className="text-[13px] leading-relaxed text-slate-500">{c.footer.disclaimer}</p>
        </div>
      </div>
    </footer>
  );
}
